import {all, call, put, takeLatest} from "redux-saga/effects";
import queryString from "query-string";
import {normalize, schema} from "normalizr";
import {toast} from "react-toastify";

import {getErrorMessage} from "../../../../utils/sagasErrorHandler";
import messageHelper from "../../../../utils/messages/messageHelper";

import {
    changeEnabledCredentials,
    createCredentials,
    deleteCredentials,
    editCredentials,
    getCredentials,
    getCredentialsError,
    getCredentialsSuccess,
    setCredentialsManagerDialog
} from "./actions";
import {
    getCredentialsRequest,
    deleteCredentialsRequest,
    createCredentialsRequest,
    editCredentialsRequest,
} from "./api";

const credentialsSchema = new schema.Entity("credentials");
const credentialsListSchema = new schema.Array(credentialsSchema);

//Workers
function* handleRefreshList() {
    const {search} = window.location;
    yield put(getCredentials(queryString.parse(search)));
}

function* handleGetCredentials({payload}) {
    try {
        const {count, credentials} = yield call(getCredentialsRequest, payload);
        const {result, entities} = normalize(credentials, credentialsListSchema);

        yield put(getCredentialsSuccess({
            credentials: entities.credentials,
            ids: result,
            count
        }));
    } catch (error) {
        yield put(getCredentialsError());
        getErrorMessage(error);
    }
}

function* handleCreateCredential({payload}) {
    try {
        yield call(createCredentialsRequest, payload);

        yield put(setCredentialsManagerDialog());
        yield call(toast.success, "The credential has been successfully created");

        yield handleRefreshList();
    } catch (error) {
        getErrorMessage(error);
    }
}

function* handleEditCredentials({payload}) {
    try {
        yield call(editCredentialsRequest, payload);

        yield put(setCredentialsManagerDialog());
        yield call(toast.success, `The credential with ID - ${payload.id} has been successfully edited`);

        yield handleRefreshList();
    } catch (error) {
        getErrorMessage(error);
    }
}

function* handleDeleteCredentials({payload}) {
    try {
        yield all(payload.map((payload) => call(deleteCredentialsRequest, payload)));
        messageHelper({
            type: "success",
            actionSubject: `Credential${payload.length > 1 ? "s" : ""} with id${payload.length > 1 ? "s" : ""} - ${payload.join(", ")}`,
            action: "deleted",
            plural: payload.length > 1
        });

        yield handleRefreshList();
    } catch (error) {
        getErrorMessage(error);
    }
}

function* handleChangeEnabledCredentials ({ payload }) {
    try {
        yield call(editCredentialsRequest, payload.credential);

        yield put(setCredentialsManagerDialog());
        let action = "disabled"
        if (payload.credential.enabled) {
            action = "enabled"
        }
        yield call(toast.success, `The credential with ID - ${payload.credential.id} has been successfully ${action}`);

        yield handleRefreshList();
    } catch (error) {
        getErrorMessage(error);
    }
}

// Watchers
export function* credentialsSagas() {
    yield all([
        yield takeLatest(getCredentials, handleGetCredentials),
        yield takeLatest(createCredentials, handleCreateCredential),
        yield takeLatest(deleteCredentials, handleDeleteCredentials),
        yield takeLatest(editCredentials, handleEditCredentials),
        yield takeLatest(changeEnabledCredentials, handleChangeEnabledCredentials)
    ]);
}
